export default "__VITE_ASSET__B8mfBBPP__"